import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Radio } from 'components/atoms/radio';
import { toastService } from 'components/molecules/toast';
import { BodyLong01 } from 'components/styles';
import { useTranslate } from 'hooks/use-translation';
import { useAccountMetaQuery } from 'queries';
import {
  useLoginPolicy,
  useMutateLoginPolicy,
  useQueryIdps,
} from 'queries/saml';
import { SubCategoryWrapper, SubTitle } from './component';
import { getLoginPolicyDisplayValue, getLoginPolicyPayload } from './utils';

enum LoginPolicyDisplayType {
  Optional = 'Optional',
  Only = 'Only',
}

const Description = styled.p`
  ${BodyLong01};
  margin-bottom: 0;
  color: var(--gray-70);
`;

export const LoginPolicy: FC = () => {
  const { data: loginPolicy, isLoading } = useLoginPolicy();
  const { mutate, isLoading: isUpdating } = useMutateLoginPolicy();
  const translate = useTranslate();
  const { data: accountMeta } = useAccountMetaQuery();
  const selectedValue = getLoginPolicyDisplayValue(accountMeta, loginPolicy);
  const { data: samlConfigs } = useQueryIdps();

  const onChange = (e) => {
    const payload = getLoginPolicyPayload(
      e.target.value,
      accountMeta,
      loginPolicy,
      samlConfigs,
    );

    if (!payload) {
      return;
    }

    mutate(payload, {
      onSuccess: () =>
        toastService({
          title: translate('config.saved'),
          message: translate('settings.login-policy.success'),
        }).success(),
    });
  };

  // TODO: change to form
  return (
    <SubCategoryWrapper>
      <div>
        <SubTitle>
          <FormattedMessage id="settings.login-policy.title" />
        </SubTitle>
        <Description>
          <FormattedMessage id="settings.login-policy.body" />
        </Description>
      </div>
      <Radio.Group
        onChange={onChange}
        value={selectedValue}
        disabled={isLoading || isUpdating}
      >
        <Radio value={LoginPolicyDisplayType.Optional}>
          <FormattedMessage id="settings.login-policy.option.optional" />
        </Radio>
        <Radio value={LoginPolicyDisplayType.Only}>
          <FormattedMessage id="settings.login-policy.option.only" />
        </Radio>
      </Radio.Group>
    </SubCategoryWrapper>
  );
};
